var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistrationfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.287 6.56599C15.7491 6.44817 16.2335 6.44924 16.6951 6.5691C17.1568 6.68896 17.5805 6.92372 17.9269 7.25151C18.2734 7.57929 18.5312 7.98943 18.6764 8.44371C18.8216 8.89799 18.8494 9.38163 18.7573 9.84957C18.6652 10.3175 18.4562 10.7545 18.1496 11.1199C17.8431 11.4853 17.4491 11.7671 17.0043 11.9392C16.5595 12.1112 16.0784 12.1678 15.6058 12.1038C15.1332 12.0398 14.6844 11.8572 14.3014 11.573L14.8513 10.8319C15.5686 9.86513 15.8124 8.62673 15.515 7.46025L15.287 6.56599Z",
    fill: "url(#paint0_linear_3806_25553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6183 17.9547C19.0605 16.9334 17.7142 14.9139 15.9394 14.2714",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.658 11.7898C15.0406 11.9615 15.4572 12.0441 15.8764 12.0315C16.2956 12.0188 16.7064 11.9112 17.078 11.7168C17.4495 11.5224 17.7721 11.2462 18.0215 10.909C18.2708 10.5718 18.4404 10.1825 18.5175 9.77026C18.5945 9.35804 18.577 8.93371 18.4663 8.52923C18.3556 8.12475 18.1546 7.75065 17.8784 7.43513C17.6021 7.1196 17.2579 6.87087 16.8716 6.70766C16.4853 6.54445 16.067 6.47101 15.6482 6.49289",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.440552 19.18C1.30768 17.5022 2.49408 16.1235 3.89203 15.1691C5.28999 14.2147 6.85523 13.7148 8.44566 13.7148C10.0361 13.7148 11.6013 14.2147 12.9993 15.1691C14.3973 16.1235 15.5836 17.5022 16.4508 19.18",
    fill: "url(#paint1_linear_3806_25553)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.549072 18.9321C1.41031 17.4066 2.58865 16.153 3.97712 15.2852C5.36559 14.4174 6.9202 13.9629 8.49983 13.9629C10.0795 13.9629 11.6341 14.4174 13.0225 15.2852C14.411 16.153 15.5894 17.4066 16.4506 18.9321",
    fill: "url(#paint2_linear_3806_25553)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.549072 18.9321C1.41031 17.4066 2.58865 16.153 3.97712 15.2852C5.36559 14.4174 6.9202 13.9629 8.49983 13.9629C10.0795 13.9629 11.6341 14.4174 13.0225 15.2852C14.411 16.153 15.5894 17.4066 16.4506 18.9321",
    stroke: "url(#paint3_linear_3806_25553)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49988 0.927734C11.3072 0.927734 13.4237 3.66253 13.4237 6.81934C13.4237 9.97619 11.3073 12.7109 8.49988 12.7109C5.69256 12.7108 3.57605 9.97613 3.57605 6.81934C3.5761 3.66259 5.69259 0.92783 8.49988 0.927734Z",
    fill: "url(#paint4_linear_3806_25553)",
    stroke: "#051B46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3806_25553",
    x1: 20.995,
    y1: 3.85058,
    x2: 15.2347,
    y2: 10.2349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3806_25553",
    x1: 8.44566,
    y1: 9.2856,
    x2: 8.42013,
    y2: 17.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3806_25553",
    x1: 8.49983,
    y1: 13.8691,
    x2: 8.46521,
    y2: 19.0789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3806_25553",
    x1: 8.49983,
    y1: 13.9629,
    x2: 8.49983,
    y2: 18.9321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3806_25553",
    x1: 8.50003,
    y1: -7.31169,
    x2: 8.32019,
    y2: 9.09577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationfill);
export default __webpack_public_path__ + "static/media/Registration fill.6a4213a74932244f3a4e5d74e89db2e5.svg";
export { ForwardRef as ReactComponent };